import styled from "styled-components";
import HeaderImage from "./HeaderImage";
import { Copy } from "./Data/Copy";
import Button from "./Button";
import {Link} from "react-router-dom";
// import { device }  from "../utlis/device";
// import Questions from "./Questions";
// import Button from "./Button";
// import Form from "./Form";
// import Title from "./Title";
// import Ometer from "./Ometer";
// import { useStore } from "../store";
// import { FacebookShareCount, FacebookShareButton} from "react-share";

export const PageContainer = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin: 0px;
    padding: 50px;
`
const Section = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const CopyStyle = styled.div `
  width: 50%;
  padding: 10px;
`

function ShareNaughty() {
    return (
      <PageContainer>
        {
          <Section>
            <HeaderImage />
            <h1>You are on the naughty list!</h1>
            <CopyStyle> 
              {Copy[0].naughty }
            </CopyStyle>
            <Button backgroundColor="black">
              <Link to ="/">
                Take the test!
              </Link>
            </Button>
          </Section>
        }
      </PageContainer>
    );
  }
  
  export default ShareNaughty;